export enum WorkflowStepNames {
  APPROVED = 'Approved',
  COUNTER = 'Counter',
  DECLINED = 'Decline',
}

export enum LosType {
  Cudl = 1,
  DealerTrack = 2,
  Meridian = 3,
  Defi = 4,
}

export enum CudlStatus {
  APPROVED = 'APPROVE',
  COUNTER = 'COUNTER',
  DECLINED = 'DECLINE',
}

export enum ConsentStatus {
  ACTIVE = 'ACTIVE',
  WITHDRAWN = 'WITHDRAWN',
}

export enum ConsentPurposes {
  APPLICATION = 'Application',
  ADDITIONAL = 'Additional',
  MARKETING = 'Marketing',
  RAMP = 'RAMP'
}

export enum ConsentPreferences {
  APPLICATION_EMAIL = 'Application_Email',
  APPLICATION_SMS = 'Application_SMS',
  APPLICATION_CALL = 'Application_Call',

  ADDITIONAL_EMAIL = 'Additional_Email',
  ADDITIONAL_SMS = 'Additional_SMS',
  ADDITIONAL_CALL = 'Additional_Call',

  MARKETING_EMAIL = 'Marketing_Email',
  MARKETING_SMS = 'Marketing_SMS',
  MARKETING_CALL = 'Marketing_Call',
}

export enum ContactErrorMessage {
  EMAIL_MATCHING_ERROR_MESSAGE = 'must enter unique personal email that does not match co-applicant',
  CELL_PHONE_MATCHING_ERROR_MESSAGE = 'must enter unique cell phone number that does not match co-applicant',
  NO_PHONE_ERROR_MESSAGE = 'Enter a customer phone number before saving'
}

export enum CoApplicantErrorMessage {
  EMAIL_MATCHING_ERROR_MESSAGE = 'must enter unique personal email that does not match contact',
  CELL_PHONE_MATCHING_ERROR_MESSAGE = 'must enter unique cell phone number that does not match contact'
}